"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CornerBadgeWrapper = exports.CornerBadgeText = exports.CornerBadgeSide = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _colors = _interopRequireDefault(require("../../styles/colors"));
var _HBText = _interopRequireDefault(require("../HBText/HBText"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var BADGE_HEIGHT = 20;
var HORIZONTAL_PADDING = 6;
var BADGE_SIDE_BORDER_RADIUS = 8;
var BADGE_SIDE_ROTATION = 11;
var BADGE_SIDE_SPACING = -9;
var getPositionSpecificStyles = function getPositionSpecificStyles(position) {
  switch (position) {
    case 'topRight':
      return (0, _styledComponents.css)(["right:0;flex-direction:row;padding-right:", "px;", "{left:", "px;transform:skew(", "deg);border-radius:0 0 0 ", "px;}"], HORIZONTAL_PADDING, CornerBadgeSide, BADGE_SIDE_SPACING, BADGE_SIDE_ROTATION, BADGE_SIDE_BORDER_RADIUS);
    case 'topLeft':
      return (0, _styledComponents.css)(["left:0;flex-direction:row-reverse;padding-left:", "px;", "{right:", "px;transform:skew(-", "deg);border-radius:0 0 ", "px 0;}"], HORIZONTAL_PADDING, CornerBadgeSide, BADGE_SIDE_SPACING, BADGE_SIDE_ROTATION, BADGE_SIDE_BORDER_RADIUS);
    default:
      return;
  }
};
var CornerBadgeSide = exports.CornerBadgeSide = _styledComponents["default"].div.withConfig({
  displayName: "HBCornerBadgestyles__CornerBadgeSide",
  componentId: "sc-12qcyw-0"
})(["width:12px;height:", "px;background-color:", ";position:absolute;"], BADGE_HEIGHT, _colors["default"].blue20);
var CornerBadgeText = exports.CornerBadgeText = (0, _styledComponents["default"])(_HBText["default"]).withConfig({
  displayName: "HBCornerBadgestyles__CornerBadgeText",
  componentId: "sc-12qcyw-1"
})(["color:", ";position:relative;font-weight:600;font-size:12px;"], _colors["default"].white);
var CornerBadgeWrapper = exports.CornerBadgeWrapper = _styledComponents["default"].div.withConfig({
  displayName: "HBCornerBadgestyles__CornerBadgeWrapper",
  componentId: "sc-12qcyw-2"
})(["display:flex;align-items:center;position:absolute;top:0;background-color:", ";height:", "px;", ""], _colors["default"].blue20, BADGE_HEIGHT, function (props) {
  return getPositionSpecificStyles(props.position);
});
//# sourceMappingURL=HBCornerBadge.styles.js.map